import { useCallback, useEffect, useState } from 'react'
import {
  listPlatformTenants,
  type PlatformTenantListParams,
  type PlatformTenantRow,
} from '@/api/platformApi'

const DEFAULT_PARAMS: PlatformTenantListParams = { limit: 500, page: 1 }

export function usePlatformTenantsList(params: PlatformTenantListParams = DEFAULT_PARAMS) {
  const [rows, setRows] = useState<PlatformTenantRow[]>([])
  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(params.page ?? 1)
  const [pages, setPages] = useState(1)
  const [loading, setLoading] = useState(true)
  const [erro, setErro] = useState('')

  const q = params.q ?? ''
  const ativo = params.ativo ?? 'all'
  const limit = params.limit ?? 500
  const sort = params.sort ?? 'id'
  const pageParam = params.page ?? 1

  const reload = useCallback(async () => {
    setErro('')
    setLoading(true)
    try {
      const res = await listPlatformTenants({ q, ativo, page: pageParam, limit, sort })
      setRows(res.items)
      setTotal(res.total)
      setPage(res.page)
      setPages(res.pages)
    } catch (e) {
      setErro(e instanceof Error ? e.message : 'Erro ao carregar.')
    } finally {
      setLoading(false)
    }
  }, [q, ativo, pageParam, limit, sort])

  useEffect(() => {
    reload()
  }, [reload])

  return { rows, total, page, pages, loading, erro, reload }
}
